'use client';

import { useLayoutEffect } from 'react';

import {
  enableRouteStylesheets,
  removeRouteStylesheets,
} from '@/lib/styles/route-stylesheets';

/**
 * Keeps /company-assets legal CSS enabled while the page is mounted.
 * MarketingBodyReset may disable the company group on layout mount; this
 * re-enables it and cleans up on soft-nav away from legal pages.
 */
export function CompanyLegalSheets() {
  useLayoutEffect(() => {
    enableRouteStylesheets('company');
    return () => {
      removeRouteStylesheets('company');
    };
  }, []);

  return null;
}
